import { render, staticRenderFns } from "./ProposalListPage.vue?vue&type=template&id=01fcb686&scoped=true&"
import script from "./ProposalListPage.vue?vue&type=script&lang=js&"
export * from "./ProposalListPage.vue?vue&type=script&lang=js&"
import style0 from "./ProposalListPage.vue?vue&type=style&index=0&id=01fcb686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fcb686",
  null
  
)

export default component.exports